import { flowRight } from 'lodash';
import { connect } from 'react-redux';

import { isDashboard } from '../selectors/view-mode-selectors';
import { isBusinessManager } from '../../business-manager-old/selectors/is-business-manager-selectors';
import withHocName from './with-hoc-name';

const mapStateToProps = state => ({
  useFixedButtonColor: isDashboard(state) || isBusinessManager(state),
});

export default flowRight(
  connect(mapStateToProps),
  withHocName('WithFixedButtonColor'),
);
